// db.js
import Dexie from 'dexie';

export const db = new Dexie('myDatabase');
db.version(1).stores({
  persons: '++id, name, preposition, surname, email, onServer', // Primary key and indexed props
});
